import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const TransactionFees = () => {
  const data = [
    { label: "Standard Orders", value: "2% of the total order value" },
    { label: "High-Volume Orders", value: "1.5% of the total order value for orders above $10,000" },
    { label: "Returns and Refunds", value: "$1 per return/refund process" },
  ]

  const columns = [
    { name: 'Transaction Type', selector: row => row.label },
    { name: 'Fee Structure', selector: row => row.value },
  ]

  return (
    <div>
      <div className="fw-semibold fs-5">Transaction Fees</div>

      <div className="px-5 py-2">
      <DatatableComponent data={data} columns={columns} type='yellow' />

      </div>
    </div>
  )
}

export default TransactionFees
